import {
  MDBAlert,
  MDBBtn,
  MDBCheckbox,
  MDBChip,
  MDBDatatable,
  MDBIcon,
  MDBModalFooter,
  MDBPopconfirm,
  MDBPopconfirmMessage,
  MDBSpinner,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
  MDBInput,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import mobilePhone from "../../../../src/components/images/Cell.svg";
import phoneImageActive from "../../../../src/components/images/Ip_Phone_icon.svg";
import appleImage from "../../../../src/components/images/Apple.svg";
import windowsImage from "../../../../src/components/images/Microsoft.svg";
import teamsImage from "../../../../src/components/images/teams.svg";
import androidImage from "../../../../src/components/images/Android.svg";
import iosImage from "../../../../src/components/images/iOS.svg";
import LaptopOrange from "../../../../src/components/images/laptop_orange.svg";
import { getLiveDataRegisteredDevicesInDeviceMap, getOnlineDevicesStatusForPhones, getPhoneDevicesList, sendZTPrequest, sendSyncRequest } from "../../../apiclients/streamsapi_bridge.js";
import PopupLoader from "../../../views/popups/PopupLoader.js";
import AddDevices from "../../../views/popups/phonesystem/AddDevice.js";
import UnassignDevices from "../../../views/popups/phonesystem/UnassignDevice.js";

import { useLocation, useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import UnassignedRemoveDevice from "../../../views/popups/phonesystem/UnassignedRemoveDevice.js";
import UIConstant from "../../../apiclients/UIConstant.js";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch.js";
import TabIDConstant from "../../../apiclients/TabIDConstant.js";
import { useRef } from "react";
import ReactCountryFlag from "react-country-flag"
import countries from "i18n-iso-countries";
import en from "i18n-iso-countries/langs/en.json";

countries.registerLocale(en);

export default function IPhonesAndDevices(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  // console.log(
  //   "[IPhonesAndDevices]  location state :" + JSON.stringify(location.state)
  // );
  const [isError, setError] = useState(false);
  const [reuseDevice, setReuseDevice] = useState({});
  const [showAddDevicePopup, setShowAddDevicePopup] = useState(false);
  const [deviceList, setDeviceList] = useState([]);
  const [defaultDeviceList, setDefualtDeviceList] = useState([]);
  const [withOutFilterData, setWithOutFilter] = useState([])
  const [unassigndeviceList, setUnassigndeviceList] = useState([]);
  const [unassignDevice, setunassignDevice] = useState(false);
  const unassignDeviceToggle = () => setunassignDevice(!unassignDevice);
  const [removeDevice, setremoveDevice] = useState(false);
  const removeDeviceToggle = () => setremoveDevice(!removeDevice);
  const [deviceRemoved, setDeviceRemoved] = useState(false);
  const [removeDeviceFromUnassign, setRemoveDeviceFromUnassign] = useState({});
  const [unAssignPhoneJo, setunAssignPhoneJo] = useState({});
  const [assignUnassign, setAssignUnassign] = useState(
    location.state
      ? location.state.unassign
        ? location.state.unassign
        : "assign"
      : "assign"
  );
  const [isloading, setIsloading] = useState(false);
  const [locationsList, setLocationsList] = useState();
  const [deviceModelsList, setDeviceModelsList] = useState([]);
  const [updateZtpstatus, setUpdateZtpstatus] = useState(false)
  const [searchValue, setsearchValue] = useState("");
  const [fullDeviceData, setFullDeviceData] = useState([]);
  const [fullUnassigndata, setFullUnassignData] = useState([]);
  const [unassignSearsch, setUnassignSearch] = useState("");
  const [errorMessage, seterrorMessage] = useState(false);
  const [currentUA, setCurrentUA] = useState("");
  const [currentContry, setCurrentCountry] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipText, setTooltipText] = useState("Copy");

  const [focusAssigned, setFocusAssigned] = useState(false);
  const [focusUnassigned, setFocusUnassigned] = useState(false);
  const [focusOnline, setFocusOnline] = useState(false);

  // Refs
  const assignedSearchRef = useRef(null);
  const unassignedSearchRef = useRef(null);
  const onlineSearchRef = useRef(null);

  useAutoFocusSearchAfterLoads(focusAssigned, setFocusAssigned, assignedSearchRef, assignUnassign === "assign");
  useAutoFocusSearchAfterLoads(focusUnassigned, setFocusUnassigned, unassignedSearchRef, assignUnassign === "unassign");
  useAutoFocusSearchAfterLoads(focusOnline, setFocusOnline, onlineSearchRef, assignUnassign === "list");



  useEffect(() => {
    if (props.showAddDevicePopup) {
      setShowAddDevicePopup(props.showAddDevicePopup);
    }
  }, [props.showAddDevicePopup])
  const assignList = {
    columns: [

      { label: "Phone Name", field: "PhoneName", sort: true },
      { label: "User", field: "User", sort: true },
      { label: "Extension", field: "Extension", sort: true },
      { label: "Designation", field: "Designation" },
      { label: "Location", field: "Location", sort: true },
      { label: "Model", field: "Model", sort: true },
      { label: "Mac Address", field: "MacAddress", sort: true },
      // { label: "Provisioning", field: "Provisioning" },
      {
        label: (
          <p className="text-center m-0 fw-bold">
            Online
          </p>
        ), field: "Online", sort: false
      },
      {
        label: (
          <p className="text-center m-0 fw-bold">
            ZTP Status
          </p>
        ), field: "ZeroTouch", sort: false
      },
      {
        label: (
          <p className="text-center m-0 fw-bold">
            Sync
          </p>
        ), field: "SyncConfig", sort: false
      },
      { label: "Unassign", field: "Unassign", sort: false },
    ],
    rows: deviceList,
  };



  useEffect(() => {
    const patchTitles = () => {
      const tds = document.querySelectorAll('.device-map-table td');
      tds.forEach(td => {
        const trimmed = td.textContent.trim();
        if (trimmed && td.getAttribute('title') !== trimmed) {
          td.setAttribute('title', trimmed);
        }
      });
    };

    patchTitles(); // Initial patch

    const table = document.querySelector('.device-map-table');
    if (!table) return;

    const observer = new MutationObserver(() => {
      patchTitles();
    });

    observer.observe(table, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);




  const unAssignList = {
    columns: [
      { label: "Model", field: "Model", sort: true },
      { label: "Mac Address", field: "MacAddress" },
      { label: "Reuse Device", field: "ReuseDevice", sort: false },
      { label: "Remove", field: "Delete", sort: false },
    ],
    rows: unassigndeviceList,
    /*  [
            {
                Model: "Poly VVX 601",
                MacAddress: "1234567890123456",
                ReuseDevice: "sync",
                Remove: <i className="fas fa-xmark text-primary"></i>,
            },
            {
                Model: "Poly VVX 601",
                MacAddress: "1234567890123456",
                ReuseDevice: "sync",
                Remove: <i className="fas fa-xmark text-primary"></i>,
            },
        ] */
  };

  const toggleAssignedUnassigned = (data) => {
    setAssignUnassign(data);
  if (data === "assign") setFocusAssigned(true);
  if (data === "unassign") setFocusUnassigned(true);
  };

  useEffect(() => {
    console.log("get list Data :: " + assignUnassign)
    if (assignUnassign === "list") {
      setdeviceMapList([])
      getLiveApiDataDevicesInfo();
    }
  }, [assignUnassign]);


  const toggleAddDevicePopup = () => {
    setShowAddDevicePopup(!showAddDevicePopup);
    console.log(showAddDevicePopup);
  };

  const closePopup = () => {
    setShowAddDevicePopup(false);
    setReuseDevice({}); //Clearing Reuse device info on saving and closing popup 
  };

  /*Added By :Ganesh
   * This method will remove existing state for  roauter
   */
  const removeStateVariables = () => {
    console.log("");
    navigate("/pslanding", {
      state: null,
    });
  };

  const handleReuseDevice = (item) => {
    console.log("Methd is called : " + JSON.stringify(item));
    try {
      let reuse_jo = {};
      reuse_jo.macaddress = item.macAddress;
      reuse_jo.provisioning_type = 1;
      reuse_jo.devicename = item.modelName;
      reuse_jo.devType = 1;
      reuse_jo.reuseDevice = "reuseDevice";
      reuse_jo.ipphonetype_id = item.ipphonetype_id
      setReuseDevice(reuse_jo);
      toggleAddDevicePopup()
    } catch (e) {
      console.error("Error in while calling handleReuseDevice :" + e);
    }

  }
  const handleSyncRequest = async (e, deviceUUID) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.classList.add("rotateSyncIcon")
    if (!deviceUUID) {
      console.error("Device UUID is missing for sync request.");
      return;
    }
    console.log("Sync button clicked for device UUID:", deviceUUID);
    try {
      const jsonObj = {
        devices: [deviceUUID]
      }
      console.log("Sending sync request with payload:", JSON.stringify(jsonObj));
      const response = await sendSyncRequest(jsonObj);
      let responseData = await response.json();
      if (responseData?.status == 200) {
        localStorage.setItem("s_message", "Sync completed successfully.");
        setUpdateZtpstatus(!updateZtpstatus);
        navigate(0)
      } else {
        console.error("Sync request failed with error:", responseData.error);
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 2000);
        throw new Error("Sync request failed");
      }

    } catch (error) {
      console.error("Error in handleSyncRequest:", error);
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 3000);
    }
    setTimeout(() => {
      e.target.classList.remove("rotateSyncIcon")
    }, 1000)
  };

  function parseCountry(input) {
    if (!input) return { code: null, name: null };
  
    const raw = input.trim();
    const upper = raw.toUpperCase();
  
    const IGNORE_WORDS = ["the", "of", "and"];
  
    function getFormattedName(alpha2) {
      const fullName = countries.getName(alpha2, "en");
      const words = fullName.split(/\s+/);
  
      if (words.length <= 2) {
        return fullName; // simple names return normal
      }
  
      // Remove filler words
      const filtered = words.filter(
        w => !IGNORE_WORDS.includes(w.toLowerCase())
      );
  
      // Take first letter of each main word
      const shortCode = filtered.map(w => w[0].toUpperCase()).join("");
  
      return shortCode;
    }
  
    // Case 1: Valid 2-letter code
    if (upper.length === 2 && countries.isValid(upper)) {
      return {
        code: upper,
        name: getFormattedName(upper)
      };
    }
  
    // Case 2: Valid 3-letter code
    if (upper.length === 3) {
      const alpha2 = countries.alpha3ToAlpha2(upper);
      if (alpha2) {
        return {
          code: alpha2,
          name: getFormattedName(alpha2)
        };
      }
    }
  
    // Case 3: Country name
    const alpha2FromName = countries.getAlpha2Code(raw, "en");
    if (alpha2FromName) {
      return {
        code: alpha2FromName,
        name: getFormattedName(alpha2FromName)
      };
    }
  
    return { code: null, name: raw };
  }
  
  
  
  


  const fetchData = async () => {
    try {
       setIsloading(true);
      sessionStorage.setItem("current_link", "pslanding");
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      let saverepData = await getPhoneDevicesList(siteid, TabIDConstant.DEVICES_SUBLINK);
      // console.log('server data ')

      if (!saverepData.ok) {


        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        let saverepeMsg = await saverepData.json();
        let assignedListArray = saverepeMsg.phoneDetails.assigned_list;
        let unAssignedListArray = saverepeMsg.phoneDetails.unassigned_list;
        let assignedphoneDetails = [];
        assignedListArray.forEach((item, index) => {
          let jsonframe = {};
          jsonframe.PhoneName = item.phoneName;
          jsonframe.User = item.phoneOwner;
          jsonframe.Extension = item.extention;
          jsonframe.Designation = item.ipPhoneType;
          jsonframe.Location = item.address;
          jsonframe.Model =
            item.provisiongType === "Manual" || item.provisiongType === "manual"
              ? "Manual"
              : item?.modelName;
          // jsonframe.Model = (
          //   <div title={item.modelName}>
          //     {item.provisiongType == "Manual" ||
          //       item.provisiongType == "manual"
          //       ? `Manual`
          //       : item.modelName}
          //   </div>
          // );
          jsonframe.MacAddress = item.macAddress;
          // jsonframe.Provisioning = item.provisiongType == 'Manual' || item.provisiongType == 'manual' ? `[Manual]  ${item.modelName}` : item.modelName;
          jsonframe.Online = <div key={index} style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="red-dot"></div>
          </div>;
          jsonframe.ZeroTouch = (
            <div key={index} style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
              {
                item.provisiongType == "Auto" && UIConstant.ZTP_ALLOWED_DEVICES.includes(item?.modelName.split(' ')[0]) ? (
                  item.zeroTouchStatus == 1 ? (
                    <span className="green-dot ZeroTouchRow"></span>
                  ) : (
                    <a onClick={(e) => handleEnroll(e, item?.macAddress, item?.modelName)} style={{ width: "100%", height: "100%", textDecoration: "underline", display: "flex", justifyContent: "center", alignItems: "center" }}>
                      Enroll
                    </a>
                  )
                ) : <p>-</p>
              }
            </div>
          );
          jsonframe.deviceId = item.deviceId;
          jsonframe.provisioning_method = item.provisioning_method;
          jsonframe.agentId = item.agentId;
          jsonframe.deviceUUID = item.deviceUUID;
          jsonframe.SyncConfig = item.provisiongType === "Auto" && <div key={index} style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="">-</div>
          </div>

          jsonframe.Unassign = (
            // <span title="Unassign"><i
            //   className="ms-4 fas fa-xmark text-primary"
            //   onClick={(e) => handleunassignDevice(e, jsonframe)}
            // ></i></span>

            <div className="d-flex align-items-center justify-content-center">
              <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => handleunassignDevice(e, jsonframe)}>
                <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
              </div>
            </div>
          );
          assignedphoneDetails.push(jsonframe);
        });
        const handleEnroll = async (e, macAddress, modelName) => {
          // Logic to handle enrollment, potentially updating the zeroTouchStatus in the database
          const jsonObj = { type: "enroll", macaddress: macAddress, devicename: modelName };
          e.preventDefault();
          e.stopPropagation();
          console.log("Enroll button clicked for macAddress ", macAddress);
          try {
            const response = await sendZTPrequest(JSON.parse(sessionStorage.getItem("admin_session"))?.siteid, jsonObj);
            console.log("response :::: " + response);
            let saverepeMsg = await response.json();
            if (!response.ok) {
              console.log("Network response was not ok handleEnroll sendZTPrequest ");
              setError(true);
              seterrorMessage(saverepeMsg.message)
            setTimeout(() => {
                setError(false);
              }, 3000);
              throw new Error("Network response was not ok");
            } else {
              if (saverepeMsg.status == "success") {
                localStorage.setItem("s_message", "Enrolled successfully.");
                setUpdateZtpstatus(!updateZtpstatus);
                navigate(0)
              }
            }
          } catch (error) {
            console.log("Network response was not ok [handleEnroll] [sendZTPrequest] " + error);
          }
        };

        console.log("assignedListArray :::: " + JSON.stringify(assignedListArray));
        frameFilterDropdowns(assignedListArray);
        setDeviceList(assignedphoneDetails);
        setDefualtDeviceList(assignedphoneDetails)
        setFullDeviceData(assignedphoneDetails);
        setWithOutFilter(assignedphoneDetails);
        deviceList.map(data => {
          console.log("Model :::: " + data.Model);
        })
        let unAssignedphoneDetails = [];
        unAssignedListArray.forEach((item) => {
          let recordJo = {};
          recordJo.Model = item.modelName;
          recordJo.MacAddress = item.macAddress;
          recordJo.ReuseDevice = (


            <div className="d-flex align-items-center ms-4">
              <div className="custom-hover-bg p-1 cursor-pointer ReuseDevice" onClick={() => handleReuseDevice(item)}>
                {/* <img src={syncIcon} className="mx-2 syncIcon" /> */}
                <MDBIcon fas icon="sync-alt" color="primary" className="mx-2 my -1 fs-5" />
              </div>
            </div>
            // <div title="Reuse Device">
            //   <img
            //     src={syncIcon}
            //     className="syncIcon cursor-pointer mt-1"
            //     alt="Sync Icon"
            //     onClick={() => handleReuseDevice(item)}
            //   ></img>

            // </div>
          )
          recordJo.Delete = (
            <div className="d-flex align-items-center justify-content-center">
              <div className="custom-hover-bg p-1 cursor-pointer unassign" onClick={(e) => handleRemoveDevice(e, item)}>
                <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
              </div>
            </div>

            // <span title="Remove"><i
            //   className="ms-3 fas fa-xmark text-primary"
            //   onClick={(e) => handleRemoveDevice(e, item.macAddress)}
            // ></i></span>
          );
          unAssignedphoneDetails.push(recordJo);
        });

        setUnassigndeviceList(unAssignedphoneDetails);
        setFullUnassignData(unAssignedphoneDetails);
        setOnlineDeviceStatus(assignedphoneDetails);

      }
      removeStateVariables();
    } catch (e) {
      console.log("[PSLanding.js] Error while fetching data from API : " + e);
      setTimeout(() => {
        setIsloading(false)
      }, 1000)
    }
    setTimeout(() => {
      setFocusAssigned(true); // Focus search after table load
     },1000)
  };
  const setOnlineDeviceStatus = async (assignedphoneDetails) => {
    try {
      console.log("assignedphoneDetails :: " + JSON.stringify(assignedphoneDetails));
      let devices = assignedphoneDetails.map((obj) => obj.deviceUUID).filter(data => data != "");
      console.log(" configDevices devices ::: ", devices);
      var paramsJo = {
        devicesList: devices,
      };

      console.log("praramJO: " + JSON.stringify(paramsJo));
      var api_response = await getOnlineDevicesStatusForPhones(JSON.parse(sessionStorage.getItem("admin_session")).siteid, paramsJo);
      console.log("api_response ::: " + JSON.stringify(api_response));
      let response = await api_response.json();
      var livedataObjectsInfo = response.deviceStatus;
      if (!api_response.ok) {
        console.log("Server response was not ok");
      }
      console.log("livedataObjectsInfo ::: " + JSON.stringify(livedataObjectsInfo));
      let configured_devices_withstatus = [];
      for (const data of assignedphoneDetails) {
        let result = livedataObjectsInfo.find(
          (liveobj) => data?.deviceUUID == liveobj?.device_uuid
        );
        data.Online = result?.online_status ? (
          <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="green-dot ms-4"></div>
          </div>
        ) : (
          <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="red-dot ms-4"></div>
          </div>
        );
        data.SyncConfig = result?.online_status && data.Model !== "Manual" ? (
          <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <MDBIcon fas icon="sync-alt" color="primary" className="fs-5 mt-1 cursor-pointer" onClick={(e) => handleSyncRequest(e, data.deviceUUID)} />
          </div>
        ) : (
          <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div>-</div>
          </div>
        );
        configured_devices_withstatus.push(data);
      }

      setDeviceList(configured_devices_withstatus);

      // if (searchValue) {
      //   let searchDevices = globalSearch(searchValue, 1);
      //   setDeviceList(searchDevices);
      // }
      setTimeout(() => {
        setIsloading(false)
      }, 1000)

    } catch (error) {
      console.log("Error while fetching Online status for devices ::: " + error);
      setTimeout(() => {
        setIsloading(false)
      }, 1000)
    }

  }


  function frameFilterDropdowns(assignedListArray) {
    try {
      console.log("frameFilterDropdowns Data ::  " + JSON.stringify(assignedListArray));
      setLocationsList([...new Set(assignedListArray.map(data => data.address.replace(/-/g, '').trim())
        .filter(location => location !== ''))]
        .map(location => (location)));
      setDeviceModelsList([...new Set(assignedListArray.map(data => ({
        ...data, Model: data.modelName == "-" ? data.modelName.replace(/-/g, '') // Replace '-' if modelName is exactly '-'
          : data.modelName.replace(/Manual/g, '')// Apply the usual replacement logic
      })).filter(data => data.Model !== '' && !UIConstant.UNSUPPORTED_DEVICE_MODELS.includes(data.Model)).map(data => data.Model))]
        .map(Model => (Model)));
    } catch (e) {
      console.log("frameFilterDropdowns Error ::  " + e);
    }
  }

  useEffect(() => {
    fetchData();
  }, [updateZtpstatus]);

  const handleunassignDevice = (e, param1) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("request came to handle :" + param1);
    setunAssignPhoneJo(param1);
    unassignDeviceToggle();
    console.log(param1);
  };

  const handleRemoveDevice = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("request came to handle item :::: " + JSON.stringify(item));
    setRemoveDeviceFromUnassign(item);
    setremoveDevice(true);
  };


  const copyToClipboard = async (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            console.log("Copied:", text);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    } else {
        // fallback for insecure contexts
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        console.log("Copied with fallback:", text);
    }
    setTooltipText("Copied!");
    setShowTooltip(true)
};

  function showThisInf(row) {
    try {
      console.log("showThisInf :: " + row);
      const provisioningMethod = row?.provisioning_method * 1;
      console.log("row.provisioning_method :" + row.provisioning_method)
      const selMember = provisioningMethod === 1 ? row?.MacAddress : row?.deviceUUID
      const currentIndex = defaultDeviceList.findIndex((tmdata) => provisioningMethod === 1 ? tmdata.MacAddress == selMember : tmdata.deviceUUID === selMember);
      const preDeviceInfo = currentIndex > 0 ? defaultDeviceList[currentIndex - 1] : null;
      const nextDeviceInfo = currentIndex < defaultDeviceList.length - 1 ? defaultDeviceList[currentIndex + 1] : null;

      const combinedData = {
        selMember,
        preDeviceInfo,
        nextDeviceInfo,
        deviceList: defaultDeviceList
      }
      if (row.provisioning_method * 1 == 1) {
        navigate("/ipphoneadd", {
          state: { macAdress: row.MacAddress, device: JSON.stringify(combinedData) },
        });
      } else if(row.provisioning_method == 3){
        navigate("/YealinkSettings", {
          state: { macAdress: row.MacAddress, device: JSON.stringify(combinedData) },
        });
      }else if (row.provisioning_method == 2){
          navigate("/manualdevicesettings", {
          state: {
            deviceUUID: row.deviceUUID, device: JSON.stringify(combinedData)
          },
        });
      }
    } catch (error) {
      console.error("Error in showThisInf:", error);
    }
  }

  const [deviceMapList, setdeviceMapList] = useState([]);
  const [fullDeviceMapList, setFullDeviceMapList] = useState([]);
  const [onlineSearch, setOnlineSearch] = useState("");
  const [data, setData] = useState(null);

  async function getLiveApiDataDevicesInfo() {
    try {
      console.log("getLiveApiDataDevicesInfo  node server request for List :");
      setIsloading(true);
      let apirespone = await getLiveDataRegisteredDevicesInDeviceMap(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );

      console.dir(apirespone);
      if (!apirespone.ok) {
        console.log(
          "Network response was not ok ! there might be some issue exist at api-server"
        );

        //throw new Error('Network response was not ok');
        // setData(datahard); //sample data to test in local network
      } else {
        if (apirespone.status == 200) {

          let responseData = await apirespone.json();
          let responseDevices = responseData.devices;
          let devices = [];
          responseDevices.parkData?.forEach(element => {
            let json = {};
            json.device =
              <td>
                {element.device_type == 4 ? ( <img src={teamsImage} alt="Phone Active" /> )  :element.device_type === 1 ? ( <img src={phoneImageActive} alt="Phone Active" /> ) : element.device_type === 2 ? ( element.properties?.model?.toLowerCase()?.includes("mac") ? ( <img src={appleImage} alt="Apple Mac" /> ) : ( <img src={windowsImage} alt="Laptop Orange" /> ) ) : element.device_type === 3 && element.properties.model?.toLowerCase()?.includes("ios") ? ( <img src={iosImage} alt="Mobile Phone" /> ) : ( <img src={androidImage} alt="Default Laptop" /> ) }
              </td>
            json.phonename = element.properties.phonename;
            json.user = element.properties.username;
            json.designation = element.properties?.phone_designation == 1 ? "IP Phone 1" : element.properties?.phone_designation == 2 ? "IP Phone 2" : "Softphone";
            json.location = element.geometry.regionName;
            json.modelText = element.properties.mac_address == "Manual" ? element.properties.mac_address : element.properties.model;
            json.model = (
              <div style={{ display: "flex", alignItems: "center", gap: "4px", whiteSpace: "nowrap" }}
             >
                <span>{json.modelText}</span>
                <MDBIcon
                  fas
                  icon="info-circle"
                  style={{ fontSize: "12px", cursor: "pointer" }}
                  className="ps-2 table-icfo-icon table-info"
                  data-tooltip-id="tooltip-volume"
                  data-tooltip-content="custom"
                  onMouseEnter={() => setCurrentUA(element.user_agent)}   // <-- IMPORTANT
                />
              </div>
            );
            json.ipAdress = element.properties.mac_address;
            json.registeredipText = element.properties.src_ip;
            json.registeredip = (
              <div style={{ display: "flex", alignItems: "center", gap: "4px", whiteSpace: "nowrap" }}
             >
                <p className='fw-normal mb-1 d-flex align-items-center gap-1'><ReactCountryFlag countryCode={parseCountry(element.geometry.country)?.code} svg/>{json.registeredipText} </p>
                <MDBIcon
                  fas
                  icon="info-circle"
                  style={{ fontSize: "12px", cursor: "pointer" }}
                  className="ps-2 pb-1  table-icfo-icon table-info"
                  data-tooltip-id="tooltip-country"
                  data-tooltip-content="custom"
                  onMouseEnter={() => setCurrentCountry(`${toPlainAlphabet(`${element.geometry.city.charAt(0).toUpperCase() + element.geometry.city.slice(1).toLowerCase()}`)},${parseCountry(element.geometry.country)?.name}`)}   // <-- IMPORTANT
                />
              </div>
            );
            json.registerTo = element.pop;
            json.transport = element.properties.transport;
            json.software = (element.device_type !== 1) ? element.properties.softeware_version : '-';
            devices.push(json);
          });
          setdeviceMapList(devices);
          setFullDeviceMapList(devices);
          console.log("devices ::::::::: " + JSON.stringify(devices));
          setData(data.devices);
          
          console.log(
            "server response is recieved : " + JSON.stringify(data.devices)
          );

        }
      }
    } catch (e) {
      console.log("Error in getLiveApiDataDevicesInfo :" + e);
    }
    
    setTimeout(() => {
      setIsloading(false);
      setFocusOnline(true)
    }, 1000);

  }

  const toPlainAlphabet = (text = "") => {
    return text
      .normalize("NFD")                 // split accented characters
      .replace(/[\u0300-\u036f]/g, "")  // remove accents
      .replace(/[^a-zA-Z\s]/g, "");     // remove anything non-alphabet (optional)
  };

  function showThisInf1(evntData) {
    console.log('evntData:', JSON.stringify(evntData));
    // Ensure that `navigate` is defined and used appropriately
    // navigate('/pslanding', {});
  }

  const PhoneDetails = {
    columns: [
      { label: "", field: "device", sort: false },
      { label: "Phone Name", field: "phonename", sort: true },
      { label: "User", field: 'user' },
      //  { label: 'Extension', field: 'extention' },
      { label: 'Designation', field: 'designation' },
      { label: 'Location', field: 'location' },
      { label: 'Model', field: 'model',sort: false },
    { label: 'Mac Address', field: 'ipAdress' },
      { label: 'Registered IP', field: 'registeredip' },
        { label: 'Registered To', field: 'registerTo' },
      { label: 'Transport', field: 'transport' },
      { label: 'Software', field: 'software' },
    ],
    rows: deviceMapList,
  };

  const [addFilter, setAddFilter] = useState(false);
  const [showLocation, setShowLocation] = useState(false);
  const [showProvisioning, setShowProvisioning] = useState(false);
  const [showDeviceTypeModel, setShowDeviceTypeModel] = useState(false);
  const [showAllBubble, setShowAllBubble] = useState(false);

  const [filterSelectedLocations, setFilterSelectedLocations] = useState([]);
  const [constantLocation, setconstantLocation] = useState([]);


  const [provisioningTypes, setProvisioningTypes] = useState([]);
  const [constantTypes, setconstantTypes] = useState([]);

  const [filterModels, setFilterModels] = useState([]);
  const [constantfilterModels, setconstantfilterModels] = useState([]);


  const [selectedModelChip, setSelectedModelChip] = useState("");
  const [selectedLocationchips, setSelectedLocationchips] = useState("");
  const [provisioningTypeChips, setProvisioningTypeChips] = useState("");
  const [loc, setLoc] = useState(false);

  const toggleFilter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAddFilter(!addFilter);
    setShowLocation(false);
    setShowProvisioning(false);
    setShowDeviceTypeModel(false);
    setShowAllBubble(false);
  };

  const closeFilterPopup = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAddFilter(false); // This will close the popup when "Cancel" is clicked
  };

  const toggleLocation = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowLocation(!showLocation);
    resetFilters("location");
  };

  const toggleProvisioning = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowProvisioning(!showProvisioning);
    resetFilters("provisioning");
  };

  const toggleDeviceTypeModel = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowDeviceTypeModel(!showDeviceTypeModel);
    resetFilters("deviceTypeModel");
  };


  const resetFilters = (filter) => {
    if (filter !== "location") setShowLocation(false);
    if (filter !== "provisioning") setShowProvisioning(false);
    if (filter !== "deviceTypeModel") setShowDeviceTypeModel(false);
    if (filter !== "allBubble") setShowAllBubble(false);
  };

  const toggleBackClick = (event, value) => {
    if (value == 1) {
      setFilterSelectedLocations([]);
    } if (value == 2) {
      setProvisioningTypes([]);
    } if (value == 3) {
      setFilterModels([]);
    }
    event.preventDefault();
    event.stopPropagation();
    setShowLocation(false);
    setShowProvisioning(false);
    setShowDeviceTypeModel(false);
    setShowAllBubble(false);
  };

  function handleFilterLocations(filterLocations) {
    try {
      const updatedValues = [...filterSelectedLocations]; // Clone the current state array


      if (updatedValues.includes(filterLocations)) {
        updatedValues.splice(updatedValues.indexOf(filterLocations), 1);
      } else {
        updatedValues.push(filterLocations);
      }
      setShowLocation(true);
      setFilterSelectedLocations(updatedValues); // Update the state
      // setconstantLocation(updatedValues);
      console.log("constant location set:::::::::::::::" + JSON.stringify(constantLocation))
      console.log("Updated filterSelectedLocations: ", JSON.stringify(updatedValues)); // Log the updated array
    } catch (error) {
      console.log("Error in handleprovisioningTypes:", error);
    }
  };
  function selectFilterModel(model) {
    try {
      console.log("model: " + model);
      let updatedValues = [...filterModels]; // Clone the current state array
      if (updatedValues.includes(model)) {
        updatedValues.splice(updatedValues.indexOf(model), 1);
      } else {
        updatedValues.push(model); // Add the model
      }
      setShowDeviceTypeModel(true);
      setFilterModels(updatedValues);
      // setconstantfilterModels(updatedValues);
      console.log("setFilterModels: ", JSON.stringify(updatedValues)); // Log the updated array
    } catch (error) {
      console.log("Error in setFilterModels:", error);
    }
  }

  function filterLocations(e, selectedLocations, second) {
    try {
      console.log("deviceList " + JSON.stringify(deviceList));

      if (selectedLocations.length > 0 && second != 2) {
        e.preventDefault();

        console.log("filterLocations:11", JSON.stringify(selectedLocations));
        let locationFilterData = deviceList.filter(data =>
          selectedLocations.some(location => data.Location.includes(location)));
        let locationsChipData = selectedLocations.map((item, index) => index == 0 ? `Location : ${item}` : item).join(", ");
        console.log("locationFilterData :: " + JSON.stringify(locationFilterData));
        setSelectedLocationchips(locationsChipData);
        setDeviceList(locationFilterData);
        setShowLocation(!showLocation);
        setFilterSelectedLocations(selectedLocations); // Update the state
        const result = applyAllFilters(withOutFilterData);
        setDeviceList(result);
        setconstantLocation(selectedLocations);
      } else {
        console.log("No locations selected, resetting device list.");
      }
      if (second == 2) {
        console.log("filterLocations:", JSON.stringify(selectedLocations));
        let locationFilterData = withOutFilterData.filter(data =>
          selectedLocations.some(location => data.Location.includes(location)));
        let locationsChipData = selectedLocations.map((item, index) => index == 0 ? `Location : ${item}` : item).join(", ");
        console.log("locationFilterData :: " + JSON.stringify(locationFilterData));
        setSelectedLocationchips(locationsChipData);
        setDeviceList(locationFilterData);
        setShowLocation(!showLocation);
        console.log("showLocation " + showLocation)
        setFilterSelectedLocations(selectedLocations); // Update the state
        setconstantLocation(selectedLocations);
      }
    } catch (e) {
      console.log("Error in filterLocations:", e);
    }
  }

  function ApplyfilterModel(selectedmodel, second) {
    try {
      const modelsArray = Array.isArray(selectedmodel) ? selectedmodel : [selectedmodel];
      if (modelsArray.length > 0 && second != 2) {
        console.log("models :", JSON.stringify(modelsArray));
        const filterModelsData = deviceList.filter(data =>
          modelsArray.some(model =>
            data.Model?.toLowerCase().trim() === model?.toLowerCase().trim()
          )
        );
        const modelchipData = modelsArray.map((item, index) =>
          index === 0 ? `Device Type & Model : ${item}` : item
        ).join(", ");
        setDeviceList(filterModelsData);
        setSelectedModelChip(modelchipData); // Update selected model chips
        console.log("setSelectedModelChip: " + JSON.stringify(modelchipData)); // Log updated chip data
        setFilterModels(selectedmodel);
        const result = applyAllFilters(withOutFilterData);
        setDeviceList(result);
        setconstantfilterModels(selectedmodel); // Update device list
        setShowDeviceTypeModel(!showDeviceTypeModel); // Hide model selection
      }
      if (second == 2) {
        console.log("models 22:", JSON.stringify(modelsArray));
        const filterModelsNew = withOutFilterData.filter(data =>
          modelsArray.some(model => data.Model?.toLowerCase().trim() === model?.toLowerCase().trim()));
        const modelchipData = modelsArray.map((item, index) =>
          index == 0 ? `Device Type & Model : ${item}` : item
        ).join(", ");
        setSelectedModelChip(selectedmodel); // Update selected model chips
        console.log("setSelectedModelChip: " + JSON.stringify(modelchipData)); // Log updated chip data
        setFilterModels(selectedmodel);
        setconstantfilterModels(selectedmodel);  // Update device list
        setDeviceList(filterModelsNew);
        setShowDeviceTypeModel(!showDeviceTypeModel); // Hide model selection
      }
    } catch (e) {
      console.log("Error in filterModel:", e);
    }
  }

  function handleProvisioningDevise(value) {
    try {
      console.log("handleProvisioningDevise ::: " + value);
      setProvisioningTypes(prev => [...prev, value]);
      // setconstantTypes(pre => [...pre, value]);
      setShowProvisioning(true);
    } catch (e) {
      console.log("Error in handleProvisioningDevise:", e);
    }
  }

  function handleProvisioningChange(filterDesignation, second) {
    try {
      console.log("filterDesignation ::: ", filterDesignation);
  
      //  just store selected provisioning types
      setProvisioningTypes(filterDesignation);
      setconstantTypes(filterDesignation);

      let chipText = "";
      if (filterDesignation.length > 0) {
        chipText =
          "Provisioning Type : " + filterDesignation.join(", ");
      }
  
      setProvisioningTypeChips(chipText);
  
      //  apply all filters + search together
      const result = applyAllFilters(withOutFilterData);
  
      setDeviceList(result);
  
      //  close popup
      setShowProvisioning(false);
  
    } catch (e) {
      console.log("Error in handleProvisioningChange:", e);
    }
  }

  function clearFilterData() {
    setFilterSelectedLocations([]);
    setFilterModels([]);
    setProvisioningTypes([]);
    setSelectedLocationchips("");
    setSelectedModelChip("");
    setProvisioningTypeChips("");
    setconstantLocation([]);
    setconstantTypes([]);
    setconstantfilterModels([]);
  
    // const result = applyAllFilters(withOutFilterData, "");
  
    setDeviceList(fullDeviceData);
  }


  function locationClosePopup() {
    setFilterSelectedLocations(constantLocation);
  }
  function typesClosePopup() {
    setProvisioningTypes(constantTypes);
  }
  function modelsClosePopup() {
    setFilterModels(constantfilterModels);
  }

  function firstClose(e) {
    if (constantLocation.length == 0 || constantTypes.length == 0 || constantfilterModels.length == 0) {
      setFilterSelectedLocations(constantLocation);
      setProvisioningTypes(constantTypes);
      setFilterModels(constantfilterModels);
    }
  }
  // Dependency array
  function handleDelete(value, deleteFilterData) {
    console.log("value " + value);
  
    //  Always start from original data
    let filterData = [...withOutFilterData];
  
    //  1. LOCATION REMOVE
    if (value === 1 && deleteFilterData.length > 0) {
      console.log("Removing location filters");
  
      // clear location
      setFilterSelectedLocations([]);
      setSelectedLocationchips("");
      setconstantLocation([]);
  
      //  apply remaining filters
  
      // Provision
      if (provisioningTypes.length > 0) {
        if (provisioningTypes.includes('Manual') && !provisioningTypes.includes('Auto')) {
          filterData = filterData.filter(d => d.Model === 'Manual');
        } else if (provisioningTypes.includes('Auto') && !provisioningTypes.includes('Manual')) {
          filterData = filterData.filter(d => d.Model !== 'Manual');
        }
      }
  
      // Model
      if (filterModels.length > 0) {
        filterData = filterData.filter(d =>
          filterModels.some(model =>
            d.Model?.toLowerCase().trim() === model?.toLowerCase().trim()
          )
        );
      }
  
      setDeviceList(filterData);
    }
  
    //  2. PROVISION REMOVE
    else if (value === 2 && deleteFilterData.length > 0) {
      console.log("Removing provisioning filters");
  
      // clear provisioning
      setProvisioningTypes([]);
      setProvisioningTypeChips("");
      setconstantTypes([]);
      setShowProvisioning(false);
  
      // apply remaining filters
  
      // Location
      if (filterSelectedLocations.length > 0) {
        filterData = filterData.filter(d =>
          filterSelectedLocations.some(loc => d.Location.includes(loc))
        );
      }
  
      // Model
      if (filterModels.length > 0) {
        filterData = filterData.filter(d =>
          filterModels.some(model =>
            d.Model?.toLowerCase().trim() === model?.toLowerCase().trim()
          )
        );
      }
  
      setDeviceList(filterData);
    }
  
    //  3. MODEL REMOVE
    else if (value === 3 && filterModels.length > 0) {
      console.log("Removing model filters");
  
      // clear model
      setFilterModels([]);
      setSelectedModelChip("");
      setconstantfilterModels([]);
  
      //  apply remaining filters
  
      // Provision
      if (provisioningTypes.length > 0) {
        if (provisioningTypes.includes('Manual') && !provisioningTypes.includes('Auto')) {
          filterData = filterData.filter(d => d.Model === 'Manual');
        } else if (provisioningTypes.includes('Auto') && !provisioningTypes.includes('Manual')) {
          filterData = filterData.filter(d => d.Model !== 'Manual');
        }
      }
  
      // Location
      if (filterSelectedLocations.length > 0) {
        filterData = filterData.filter(d =>
          filterSelectedLocations.some(loc => d.Location.includes(loc))
        );
      }
  
      setDeviceList(filterData);
    }
  }

  const changeSetlocation = (value) => {
    const updatedValues = [...filterSelectedLocations];
    if (updatedValues.includes(value)) {
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      updatedValues.push(value);
    }
    setShowLocation(true);
    setFilterSelectedLocations(updatedValues);
    console.log("changeSetlocation set values" + JSON.stringify(updatedValues) + " filterSelectedLocations" + JSON.stringify(filterSelectedLocations));
  };

  const changeprovisioningTypes = (value) => {
    const updatedValues = [...provisioningTypes];
    console.log("changeprovisioningTypes :: " + updatedValues)
    if (updatedValues.includes(value)) {
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      updatedValues.push(value);
    }
    setShowProvisioning(true);
    setProvisioningTypes(updatedValues);
    console.log("setProvisioningTypes set values", JSON.stringify(updatedValues));
  };

  const changeFilterModel = (value) => {
    const updatedValues = [...filterModels];
    if (updatedValues.includes(value)) {
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      updatedValues.push(value);
    }
    setShowDeviceTypeModel(true);
    setFilterModels(updatedValues);
    console.log("setFilterModels set values" + JSON.stringify(updatedValues) + " setFilterModels" + JSON.stringify(filterModels));
  };

  function isArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      console.log("arr1, arr2 " + arr1.length, arr2.length)
      return false;
    }
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();
    console.log("ELSE  " + sortedArr1.toString(), sortedArr2.toString())
    if (sortedArr1.toString() == sortedArr2.toString()) {
      return true;
    }
    return false;
  }
  function cancelFilter(value) {
    console.log("value ::::::::: " + value);
    if (value == 1) {
      setFilterSelectedLocations([]);
      setShowLocation(!showLocation);
    } if (value == 2) {
      setProvisioningTypes([]);
      setShowProvisioning(!showProvisioning);
    } if (value == 3) {
      setFilterModels([]);
      setShowDeviceTypeModel(!showDeviceTypeModel);
    }
    if (value == 4) {
      console.log("setFilterSelectedLocations " + filterSelectedLocations, "constantLocation ", constantLocation);
      setFilterSelectedLocations(constantLocation);
      setShowLocation(!showLocation);
    }
    if (value == 5) {
      console.log("provisioningTypes " + provisioningTypes, "constantTypes ", constantTypes);
      setProvisioningTypes(constantTypes);
      setShowProvisioning(!showProvisioning);
    }
    if (value == 6) {
      console.log("filterModels " + filterModels, "constantfilterModels ", constantfilterModels);
      setFilterModels(constantfilterModels)
      setShowDeviceTypeModel(!showDeviceTypeModel);
    }
  }

  const applyAllFilters = (data, searchText = searchValue) => {
    let temp = [...data];
  
    // Location filter
    if (filterSelectedLocations.length > 0) {
      temp = temp.filter(item =>
        filterSelectedLocations.some(loc =>
          item.Location?.includes(loc)
        )
      );
    }
  
    //  Model filter
    if (filterModels.length > 0) {
      temp = temp.filter(item =>
        filterModels.some(model =>
          item.Model?.toLowerCase().trim() === model?.toLowerCase().trim()
        )
      );
    }
  
    //  Provisioning filter
    if (provisioningTypes.length > 0) {
      if (
        provisioningTypes.includes("Auto") &&
        provisioningTypes.includes("Manual")
      ) {
        // no filter
      } else if (provisioningTypes.includes("Manual")) {
        temp = temp.filter(item => item.Model === "Manual");
      } else if (provisioningTypes.includes("Auto")) {
        temp = temp.filter(item => item.Model !== "Manual");
      }
    }
  
    //  Search
    if (searchText) {
      temp = customSearch(temp, searchText, UIConstant.ASSIGNLIST_FIELDS);
    }
  
    return temp;
  };

  const globalSearch = (searchValue, type) => {
    try {
      let filteredList;
      switch (type) {
        case 1:
          setsearchValue(searchValue)
          const result = applyAllFilters(withOutFilterData, searchValue);
          setDeviceList(result);
          break;
        case 2:
          setUnassignSearch(searchValue);
          filteredList = customSearch(fullUnassigndata, searchValue, UIConstant.UNASSIGNLIST_FIELDS);
          setUnassigndeviceList(filteredList);
          break;
        case 3:
          setOnlineSearch(searchValue);
          filteredList = customSearch(fullDeviceMapList, searchValue, UIConstant.ONLINELIST_FIELDS);
          setdeviceMapList(filteredList);
          break;
      }
    } catch (e) {
      console.log("Error [globalSearch] " + e);
    }
  };


  useEffect(() => {
    const patchTitles = () => {
      const tds = document.querySelectorAll('table td');
      tds.forEach(td => {
        const trimmed = td.textContent.trim();
        if (!td.getAttribute('title') || td.getAttribute('title') !== trimmed) {
          td.setAttribute('title', trimmed);
        }
      });
    };

    patchTitles();

    const table = document.querySelector('.onlineDevicesData-Table');

    if (!table) return;

    const observer = new MutationObserver(() => {
      patchTitles();
    });

    observer.observe(table, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);


  return (
    <>
      <MDBTabs>
        <MDBTabsItem>
          <MDBTabsLink
            onClick={() => toggleAssignedUnassigned("assign")}
            active={assignUnassign === "assign"}
          >
            {t("Assigned")}
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink
            onClick={() => toggleAssignedUnassigned("unassign")}
            active={assignUnassign === "unassign"}
          >
            {t("Unassigned")}
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink
            onClick={() => toggleAssignedUnassigned("list")}
            active={assignUnassign === "list"}
          >
            {t("Online")}
          </MDBTabsLink>
        </MDBTabsItem>
      </MDBTabs>
      <MDBTabsContent>
        <MDBTabsPane open={assignUnassign === "assign"}>
          <div className="position-absolute left__346px d-flex">
            {selectedLocationchips != "" && (
              <div className="d-flex">
                <div className="ms-4 popconfirmFilter">
                  <div className="me-3">
                    <MDBPopconfirm onClose={() => locationClosePopup()} className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                      <MDBChip closeIcon className="m-0" onClick={(e) => { e.preventDefault(); }} onDelete={(e) => handleDelete(1, filterSelectedLocations)}>
                        <div className="filterElliipse">
                          {selectedLocationchips}
                        </div>
                      </MDBChip>
                    </>}
                    >
                      <MDBPopconfirmMessage>
                        <div className="d-flex flex-column mt-2 cursor-pointer">
                          <div
                            className={`d-flex flex-column ${filterSelectedLocations.length > 0 ? 'Filter_disabled' : ''}`}
                            onClick={filterSelectedLocations.length > 0 ? null : toggleLocation}>
                            Location
                          </div>
                          {locationsList && locationsList.map((location) => (
                            <div key={location}>
                              <MDBCheckbox
                                name='flexCheck3'
                                value={location}
                                id={`flexCheckLocation_${location}`}
                                label={location}
                                checked={filterSelectedLocations.includes(location)}
                                onChange={() => changeSetlocation(location)}
                              />
                            </div>
                          ))}

                        </div>

                        {/* {constantLocation.length > 0 &&( */}
                        <MDBModalFooter className="d-flex align-items-center justify-content-between mt-3">
                          {showLocation && filterSelectedLocations.length > 0 && !isArraysEqual(filterSelectedLocations, constantLocation) && (
                            <div>
                              <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilter(4)}>Cancel</MDBBtn>
                              <MDBBtn size="sm" className="ms-2" onClick={(e) => filterLocations(e, filterSelectedLocations, 2)}> Apply</MDBBtn>
                            </div>
                          )}
                        </MDBModalFooter>
                        {/* )} */}
                      </MDBPopconfirmMessage>
                    </MDBPopconfirm>

                  </div>

                </div>
              </div>
            )}
            {provisioningTypeChips != "" && (
              <div className="me-3 popconfirmFilter">
                <MDBPopconfirm onClose={() => typesClosePopup()} className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                  <MDBChip closeIcon className="m-0" onClick={(e) => { e.preventDefault(); }} onDelete={(e) => handleDelete(2, provisioningTypes)}>
                    <div className="filterElliipse">
                      {provisioningTypeChips}
                    </div>
                  </MDBChip>
                </>}
                >
                  <MDBPopconfirmMessage>
                    <div className="d-flex flex-column mt-2 cursor-pointer">

                      <div
                        className={`d-flex flex-column ${provisioningTypes.length > 0 ? 'Filter_disabled' : ''}`}
                        onClick={provisioningTypes.length > 0 ? null : toggleProvisioning}>
                        Provisioning Type
                      </div>

                      <div>
                        <div>
                          <MDBCheckbox name='flexCheck4' value='' id='flexCheckProvisioning1' label='Auto' checked={provisioningTypes ? provisioningTypes.includes("Auto") : null} onChange={() => changeprovisioningTypes("Auto")} />
                        </div>
                        <div className="mt-2">
                          <MDBCheckbox name='flexCheck4' value='' id='flexCheckProvisioning2' label='Manual' checked={provisioningTypes ? provisioningTypes.includes("Manual") : null} onChange={() => changeprovisioningTypes("Manual")} />
                        </div>
                      </div>
                    </div>
                    {constantTypes && showProvisioning && (
                      <MDBModalFooter className="d-flex align-items-center justify-content-between mt-3">
                        {provisioningTypes.length > 0 && !isArraysEqual(provisioningTypes, constantTypes) && (
                          <div>
                            <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilter(5)}>Cancel</MDBBtn>
                            <MDBBtn size="sm" className="ms-2" onClick={(e) => handleProvisioningChange(provisioningTypes, 2)}> Apply</MDBBtn>
                          </div>
                        )}
                      </MDBModalFooter>
                    )}
                  </MDBPopconfirmMessage>

                </MDBPopconfirm>


              </div>

            )}
            {selectedModelChip != "" && (
              <div className="me-3 popconfirmFilter">
                <MDBPopconfirm onClose={() => modelsClosePopup()} className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                  <MDBChip closeIcon className="m-0" onClick={(e) => { e.preventDefault(); }} onDelete={(e) => handleDelete(3, filterModels)}>
                    <div className="filterElliipse">
                      {selectedModelChip}
                    </div>
                  </MDBChip>
                </>}>
                  <MDBPopconfirmMessage>
                    <div className="d-flex flex-column mt-2 cursor-pointer">
                      <div>
                        Device Type & Model
                      </div>
                      {deviceModelsList && deviceModelsList
                        .map(Model => (
                          <div key={Model}>
                            <MDBCheckbox
                              name='flexCheck3'
                              value={Model}
                              id={`flexCheckLocation_${Model}`}
                              label={Model}
                              checked={filterModels?.includes(Model)}
                              onChange={(e) => changeFilterModel(Model)}
                            />
                          </div>
                        ))}
                    </div>

                    {constantfilterModels && showDeviceTypeModel && (
                      <MDBModalFooter className="d-flex align-items-center justify-content-between mt-3">
                        {filterModels.length > 0 && !isArraysEqual(filterModels, constantfilterModels) && (
                          <div>
                            <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilter(6)}>Cancel</MDBBtn>
                            <MDBBtn size="sm" className="ms-2" onClick={(e) => ApplyfilterModel(filterModels, 2)}> Apply</MDBBtn>
                          </div>
                        )}
                      </MDBModalFooter>
                    )}
                  </MDBPopconfirmMessage>
                </MDBPopconfirm>

              </div>

            )}
            <MDBPopconfirm onClose={(e) => firstClose(e)} placement='bottom-start' onClick={toggleFilter} btnChildren={(<>  <MDBIcon fas icon="filter" className="me-2" /> {t("addFilter")}</>)}>
              <MDBPopconfirmMessage>
                <div>
                  <p className='mb-3 fw-600 filterhead'>
                    {showLocation || showProvisioning || showDeviceTypeModel
                      ? (showLocation ? "Location"
                        : showProvisioning ? "Provisioning Type"
                          : showDeviceTypeModel ? "Device Type & Model"
                            : "")
                      : "Filter by"}
                  </p>

                  {!showLocation && !showProvisioning && !showDeviceTypeModel && (
                    <>
                      <div className="d-flex flex-column mt-2 cursor-pointer">
                        <div
                          className={`d-flex flex-column ${filterSelectedLocations.length > 0 ? 'Filter_disabled' : ''}`}
                          onClick={filterSelectedLocations.length > 0 ? null : toggleLocation}>
                          Location
                        </div>
                      </div>
                      <div className="d-flex flex-column mt-2 cursor-pointer">
                        {/* <div className="cursor-pointer" onClick={toggleProvisioning}>Provisioning Type</div> */}
                        <div
                          className={`d-flex flex-column ${provisioningTypes.length > 0 ? 'Filter_disabled' : ''}`}
                          onClick={provisioningTypes.length > 0 ? null : toggleProvisioning}>
                          Provisioning Type
                        </div>
                      </div>
                      <div className="d-flex flex-column mt-2 cursor-pointer">
                        <div
                          className={`d-flex flex-column ${filterModels.length > 0 ? 'Filter_disabled' : ''}`}
                          onClick={filterModels.length > 0 ? null : toggleDeviceTypeModel}>
                          Device Type & Model
                        </div>
                      </div>
                      {/* <div className="d-flex flex-column mt-2">
                        <div className="cursor-pointer" onClick={toggleAllBubble}>ALL Devices</div>
                      </div> */}
                    </>
                  )}
                  {showLocation && locationsList.map((location) => (
                    <div key={location}>
                      <MDBCheckbox
                        name='flexCheck3'
                        value={location}
                        id={`flexCheckLocation_${location}`}
                        label={location}
                        onChange={() => handleFilterLocations(location)}
                      />
                    </div>
                  ))}

                  {showProvisioning && (
                    <div>
                      <div>
                        <MDBCheckbox name='flexCheck4' value='' id='flexCheckProvisioning1' label='Auto' onChange={() => handleProvisioningDevise("Auto")} />
                      </div>
                      <div className="mt-2">
                        <MDBCheckbox name='flexCheck4' value='' id='flexCheckProvisioning2' label='Manual' onChange={() => handleProvisioningDevise("Manual")} />
                      </div>
                    </div>
                  )}
                  <div className="filtersScroll">
                    {showDeviceTypeModel && deviceModelsList
                      .map(Model => (
                        <div key={Model}>
                          <MDBCheckbox
                            name='flexCheck3'
                            value={Model}
                            id={`flexCheckLocation_${Model}`}
                            label={Model}
                            onChange={() => selectFilterModel(Model)}
                          />
                        </div>
                      ))}
                  </div>
                  {showAllBubble && (
                    <div>
                      <div>
                        <MDBCheckbox name='flexCheck6' value='' id='flexCheckAllDevices1' label='Assigned Devices' />
                      </div>
                      <div className="mt-2">
                        <MDBCheckbox name='flexCheck6' value='' id='flexCheckAllDevices2' label='Unassigned Devices' />
                      </div>
                    </div>
                  )}

                </div>
                {showLocation && (
                  <MDBModalFooter className="d-flex align-items-center justify-content-between pt-3">
                    <MDBBtn size='sm' outline color='secondary' onClick={(e) => toggleBackClick(e, 1)} className="mx-0">Back</MDBBtn>
                    {filterSelectedLocations.length > 0 && (
                      <div>
                        <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilter(1)}>Cancel</MDBBtn>
                        <MDBBtn size="sm" className="ms-2" onClick={(e) => filterLocations(e, filterSelectedLocations)}> Apply</MDBBtn>
                      </div>
                    )}
                  </MDBModalFooter>
                )}
                {showProvisioning ? (
                  <MDBModalFooter className="d-flex align-items-center justify-content-between pt-3">
                    <MDBBtn size='sm' outline color='secondary' onClick={(e) => toggleBackClick(e, 2)} className="mx-0">Back</MDBBtn>
                    {provisioningTypes.length > 0 && (
                      <div>
                        <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilter(2)}>Cancel</MDBBtn>
                        <MDBBtn size="sm" className="ms-2" onClick={(e) => handleProvisioningChange(provisioningTypes)}> Apply</MDBBtn>
                      </div>
                    )}
                  </MDBModalFooter>
                ) : null}
                {showDeviceTypeModel && (
                  <MDBModalFooter className="d-flex align-items-center justify-content-between pt-3">
                    <MDBBtn size='sm' outline color='secondary' onClick={(e) => toggleBackClick(e, 3)} className="mx-0">Back</MDBBtn>
                    {filterModels.length > 0 && (
                      <div>
                        <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilter(3)}>Cancel</MDBBtn>
                        <MDBBtn size="sm" className="ms-2" onClick={(e) => ApplyfilterModel(filterModels)}> Apply</MDBBtn>
                      </div>
                    )}
                  </MDBModalFooter>
                )}
              </MDBPopconfirmMessage>
            </MDBPopconfirm>

            {(selectedModelChip !== "" || selectedLocationchips !== "" || provisioningTypeChips !== "") && (
              <MDBBtn className="mx-2" onClick={(e) => clearFilterData(true)} >Clear</MDBBtn>
            )}
          </div>
          <div className="IpPhoneAndDevideTable">
            <div className="deviceMapDatatable">
              <div className="d-flex justify-content-end mb-2 actionbar">
                {/*  <MDBBtn onClick={unassignDeviceToggle}>{t("unassignDevice")}
                        </MDBBtn> */}
                <MDBBtn className="ms-2" onClick={toggleAddDevicePopup}>
                  <MDBIcon fas icon="plus" size="sm" /> {t("addDevice")}
                </MDBBtn>
              </div>
              <div className='mb-2 mt-3 position-relative w-auto'>
                <MDBInput label="Search"
                  ref={assignedSearchRef}
                  value={searchValue}
                  onChange={(e) => globalSearch(e.target.value, 1)} />
                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
              </div>
              <div className='deviceMapListDataTable'>
                <MDBDatatable
                  //search
                  key={searchValue}
                  sortField="Phone Name"
                  entries={UIConstant.DEFAULT_PAGINATION}
                  noFoundMessage={t("NotFoundMessage")}
                  data={assignList}
                  fixedHeader
                  className="mt-2 actioncolumn device-map-table"
                  onRowClick={(row) => showThisInf(row)}
                />
              </div>
            </div>
          </div>
        </MDBTabsPane>
        <MDBTabsPane open={assignUnassign === "unassign"}>
          <div className="IpPhoneAndDevideTable">
            <div className='deviceMapDatatable'>
              <div class="actionbar"></div>
              <div className='mb-2 mt-3 position-relative w-auto'>
                <MDBInput label="Search"
                  ref={unassignedSearchRef}
                  value={unassignSearsch}
                  onChange={(e) => globalSearch(e.target.value, 2)} />
                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
              </div>
              <div className='deviceMapListDataTable'>
                <MDBDatatable
                  //search
                  key={unassignSearsch}
                  noFoundMessage={t("NotFoundMessage")}
                  entries={UIConstant.DEFAULT_PAGINATION}
                  data={unAssignList}
                  fixedHeader
                  sortField="Model"
                  className="mt-2 actioncolumnbig" />
              </div>
            </div>
          </div>
        </MDBTabsPane>
        <MDBTabsPane open={assignUnassign === "list"}>
          <div className="IpPhoneAndDevideTable">
            <div className='deviceMapDatatable'>
              <div class="actionbar"></div>
              <div className='mb-2 mt-3 position-relative w-auto'>
                <MDBInput label="Search"
                  ref={onlineSearchRef}
                  value={onlineSearch}
                  onChange={(e) => globalSearch(e.target.value, 3)} />
                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
              </div>
              <div className='deviceMapListDataTable'>
                <MDBDatatable
                  //search
                  key={onlineSearch}
                  sortField="Phone Name"
                  noFoundMessage={t("NotFoundMessage")}
                  entries={UIConstant.DEFAULT_PAGINATION}
                  data={PhoneDetails}
                  fixedHeader
                  className="mt-0 actioncolumnbig onlineDevicesData-Table"
                  onRowClick={(event) => {
                    showThisInf1(event);
                  }}
                />
              </div>
            </div>
          </div>
        </MDBTabsPane>
      </MDBTabsContent>

      {unassignDevice && (
        <ShowUnassignedPopup
          onclosepopup={unassignDeviceToggle}
          setshow={setunassignDevice}
          paramJo={unAssignPhoneJo}
        />
      )}
      {removeDevice && (
        <ShowRemoveDevicePopup
          onclosepopup={removeDeviceToggle}
          setshow={setremoveDevice}
          paramJo={removeDeviceFromUnassign}
          fetchData={fetchData}
          setDeviceRemoved={setDeviceRemoved}
        />
      )}
      {showAddDevicePopup && (
        <ShowAddDevicePopup reuseDeviceInfo={reuseDevice}
          unassigndeviceList={unassigndeviceList}
          onClosePopup={closePopup}
          showDevicePopup={setShowAddDevicePopup}
        />
      )}
      {isloading && (
        <div>
          <div className="loadingclass-popup"></div>
          <div className="popup-bg-loader loader_align">
            <MDBBtn disabled>
              <MDBSpinner
                size="sm"
                role="status"
                tag="span"
                className="me-2"
              />
              Loading...
            </MDBBtn>
          </div>
        </div>
      )}
      {deviceRemoved && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={10000}
        >
          Device removed successfully.
        </MDBAlert>
      )}
      {isError && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={100000}
        >
          {errorMessage}
        </MDBAlert>
      )}

      <Tooltip anchorSelect=".unassign" place="top" className="exampleTooltip">
        Remove
      </Tooltip>
      <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
        Unassign
      </Tooltip>
      <Tooltip anchorSelect=".ReuseDevice" place="top" className="exampleTooltip">
        Reuse Device
      </Tooltip>
      <Tooltip
        id="tooltip-volume"
        place="top"
        clickable
        className="exampleTooltipLight"
        render={() => (
          <div
            style={{ padding: "6px 10px", cursor: "pointer", userSelect: "none" }}
          >
            {currentUA}
            <MDBIcon far icon="copy" color="primary" size="1x" className="copyIcon me-2 ml-2 "
            onClick={() => copyToClipboard(currentUA)} />
          </div>
        )}
      />
      <Tooltip
        id="tooltip-country"
        place="top"
        clickable
        className="exampleTooltipLight"
        render={() => (
          <div
            style={{ padding: "6px 10px", cursor: "pointer", userSelect: "none" }}
          >
            {currentContry}
            <MDBIcon far icon="copy" color="primary" size="1x" className="copyIcon me-2 ml-2 "
            onClick={() => copyToClipboard(currentContry)} />
            
          </div>
        )}
      />


{showTooltip && (
                <MDBAlert
                    open
                    color="success"
                    autohide
                    className="alert-center"
                    position="bottom-right"
                    delay={2000}
                    onClose={() => setShowTooltip(false)}
                >
                    <MDBIcon far icon="check-circle" color="success" className="me-2" />

                    Copied to clipboard
                </MDBAlert>
            )}

     
    </>
  );

}

function ShowAddDevicePopup(props) {
  console.log(props);
  return (
    <>
      <PopupLoader
        title={ props.reuseDeviceInfo?.reuseDevice === "reuseDevice" ? "Reuse Device" : "Add Device"}
        content={<AddDevices replaceDeviceInfo={props.reuseDeviceInfo} unassigndeviceList={props.unassigndeviceList} onClose={(e) => props.onClosePopup()} />}
        // className={"popup-width"}
        onShow={props.showDevicePopup}
        onClose={props.onClosePopup}
      />
    </>
  );
}

function ShowUnassignedPopup(props) {
  console.log("[showUnassignedPopup] " + props);
  const { t, i18n } = useTranslation();
  var propsData = props.paramJo;
  return (
    <>
      <PopupLoader
        title={
          propsData.provisioning_method == 2
            ? t("removeDevice")
            : t("unassignDevice")
        }
        content={
          <UnassignDevices
            onClose={(e) => props.onclosepopup()}
            param={props.paramJo}
          />
        }
        // className={"popup-width"}
        onShow={props.setshow}
        onClose={props.onclosepopup}
      />
    </>
  );
}
function ShowRemoveDevicePopup(props) {
  console.log("[showUnassignedPopup] ::::::::::::::::::: " + JSON.stringify(props));
  const { t, i18n } = useTranslation();
  return (
    <>
      <PopupLoader
        title={
          t("removeDevice")
        }
        content={
          <UnassignedRemoveDevice
            onClose={(e) => props.onclosepopup()}
            param={props.paramJo}
            fetchData={props.fetchData}
            setDeviceRemoved={props.setDeviceRemoved}

          />
        }
        // className={"popup-width"}
        onShow={props.setshow}
        onClose={props.onclosepopup}
      />
    </>
  );
}